import { createContext, useContext } from 'react';
export function dateRenderfn() {}
export var Date_Content = {
  size: 'md',
  dateRender: undefined,
  yearRender: undefined,
  monthRender: undefined,
  weekRender: undefined,
  monthDateFilter: undefined
};
export var DateContentContext = createContext(Date_Content);
export var useDateContentContext = function useDateContentContext() {
  return useContext(DateContentContext);
};